const windowClingCalc = {
    $graphicWrapper: null,
    $radioSelects: null,
    $printingSelects: null,
    $allInputs: null,
    classes: {
        '337': {
            classname: 'one-sided',
            remove: ['338']
        },
        '338': {
            classname: 'two-sided',
            remove: ['337']
        },
        '339': {
            classname: 'mounted-inside',
            remove: ['340']
        },
        '340': {
            classname: 'mounted-outside',
            remove: ['339']
        },
        '341': {
            classname: 'facing-in',
            remove: ['342']
        },
        '342': {
            classname: 'facing-out',
            remove: ['341']
        }
    },
    excludeFromReviewSelectors: [
        '[name="SIDESDD"]',
        '[name="PRINTSUBSTRATEDD"]',
        '[name="OPERATIONDD2"]',
        '[name="OPERATIONDD3"]',
        '[name="MOUNTSUBSTRATEDD"]'
    ],
    _isStaticClings: false,
    init: function () {
        var $allInputs = $('.optionWrapperOn');
        this._isStaticClings = document.body.classList.contains('SLS_77299');
        this.$printingSelects = $allInputs.filter('#operation89, #operation86, #operation348');
        this.$graphicWrapper = $('.js-windowClingsView');

        // Static Window Clings (SLS_77299) only supports one-sided printing.
        // Exclude the sides radio (operation90) and force one-sided.
        if (this._isStaticClings) {
            this.$radioSelects = $allInputs.filter('#operation91, #operation92');
            var $sidesSelect = $allInputs.filter('#operation90').find('select');
            if ($sidesSelect.length && $sidesSelect.find('option[value="337"]').length) {
                $sidesSelect.val('337').trigger('change');
            } else {
                console.warn('windowClingCalc: could not force one-sided value for SLS_77299');
            }
            this.updateWrapperClasses('337');
        } else {
            this.$radioSelects = $allInputs.filter('#operation90, #operation91, #operation92');
        }

        this.$printingSelects.hide().attr('tabindex', '-1');
        this.$radioSelects.hide().attr('tabindex', '-1');

        this.prepareRadios();
        this.prepareSelects();
        this.excludeItemsFromReview();
        this.handleOptionCompatibility();
    },
    reInit: function () {
        $('[name^="duplicate"]').off('change');
        $('.radioSelectWrapper').remove();
        $('.optionWrapperOn').filter('[id^="duplicate"]').remove();
        this.init();
    },
    excludeItemsFromReview: function () {
        for (var i = 0; i < this.excludeFromReviewSelectors.length; i++) {
            $(this.excludeFromReviewSelectors[i]).addClass('excludeFromReview');
        }

        var wspMagic = window.wspMagic;
        if (wspMagic && wspMagic.generateJobSummary) {
            wspMagic.generateJobSummary();
        }
    },
    updateWrapperClasses: function (value) {
        this.$graphicWrapper.addClass(this.classes[value].classname);

        for (var i = 0; i < this.classes[value].remove.length; i++) {
            this.$graphicWrapper.removeClass(this.classes[this.classes[value].remove[i]].classname);
        }
    },
    handleOptionCompatibility: function () {
        var $wrapper = $('.js-windowClings');
        var $facingGroup = $wrapper.find('input[name="radiooperation92"]').closest('.radioSelectWrapper');

        // Static Window Clings is always one-sided, so facing is always enabled
        if (this._isStaticClings) {
            $facingGroup.removeClass('radioSelectWrapper_disabled');
            $facingGroup.find('input').prop('disabled', false);
            return;
        }

        var sidesVal = $wrapper.find('input[name="radiooperation90"]:checked').val();

        if (sidesVal === '338') {
            $facingGroup.addClass('radioSelectWrapper_disabled');
            $facingGroup.find('input').prop('disabled', true);
        } else {
            $facingGroup.removeClass('radioSelectWrapper_disabled');
            $facingGroup.find('input').prop('disabled', false);
        }
    },
    prepareRadios: function () {
        var $outerContainer = null;
        var $label = null;
        var $innerContainer = null;
        var $select = null;
        var $options = null;
        var $radioLabel = null;
        var $radio = null;
        var $tooltip = null;
        var self = this;

        for (var i = 0; i < this.$radioSelects.length; i++) {
            $select = this.$radioSelects.eq(i).find('select');
            $tooltip = this.$radioSelects.eq(i).find('.quoteHelp').clone();
            $options = $select.find('option');
            $outerContainer = $('<div class="radioSelectWrapper"></div>');
            $label = $('<span></span>');
            $innerContainer = $('<div class="radioSelectWrapperInner"></div>');

            $label.text(this.$radioSelects.eq(i).find('label.config').text());

            for (var j = 0; j < $options.length; j++) {
                $radioLabel = $('<label></label>');
                $radio = $('<input type="radio" name="radio' + $select.attr('id') + '" />');
                $radio.data('selectId', $select.attr('id'));
                $radio.attr('value', $options.eq(j).attr('value'));
                $radioLabel.text($options.eq(j).text());
                $radioLabel.append($radio);
                $radioLabel.appendTo($innerContainer);

                if ($options.eq(j).prop('selected')) {
                    $radio.prop('checked', true);
                    $radioLabel.addClass('active');
                    this.updateWrapperClasses($radio.val());
                }

                $radio.on('change', function (e) {
                    var $el = $(this);
                    var value = $el.val();
                    var $targetSelect = $('select#' + $el.data('selectId'));

                    $el.closest('.radioSelectWrapper').find('label.active').removeClass('active');
                    $el.closest('label').addClass('active');
                    $targetSelect.val(value);
                    $targetSelect.trigger('change');
                    self.updateWrapperClasses(value);
                    self.handleOptionCompatibility();
                });


            }

            $outerContainer
                .append($tooltip, $label, $innerContainer)
                .appendTo($('.js-windowClings'));
        }

    },

    //other select options - none toggle
    prepareSelects: function () {
        var $selectWrapper = null;
        var newId = null;

        for (var i = 0; i < this.$printingSelects.length; i++) {
            $selectWrapper = this.$printingSelects.eq(i).clone();
            $selectWrapper.find('select').data('selectId', $selectWrapper.attr('id'));
            newId = 'duplicate' + $selectWrapper.attr('id');
            $selectWrapper.attr('id', newId);
            $selectWrapper.find('select').attr('id', newId).attr('name', newId).addClass('excludeFromReview');
            $selectWrapper.find('select').removeAttr('onchange');
            $selectWrapper.insertBefore($('.lfVariousSettingsGroup'));
            $selectWrapper.show();

            $selectWrapper.find('select').on('change', function (e) {
                //debugger;
                var $el = $(this);
                var $targetSelect = $('select#' + $el.data('selectId'));
                $targetSelect.val($el.val());
                $targetSelect.trigger('change');
            })
        }
    }
};
export default windowClingCalc;